import { Component, inject, Input } from '@angular/core';
import { filterTypeLabel } from '@modules/filters/constants';
import { Filter } from '@modules/filters/models';
import { ModalService } from '@core/services';
import { FiltersFacade } from '@modules/filters/facades';
import { datePickerDateFormat } from '@shared/constants';
import { ModalDirective } from '@shared/directives/modal.directive';

@Component({
  standalone: false,
  selector: 'hm-remove-recent-selection-dialog',
  templateUrl: './remove-recent-selection-dialog.component.html',
  styleUrls: ['./remove-recent-selection-dialog.component.scss'],
})
export class RemoveRecentSelectionDialogComponent extends ModalDirective {
  @Input() filter!: Filter;

  protected readonly modalService = inject(ModalService);
  private readonly filtersFacade = inject(FiltersFacade);

  public readonly datePickerDateFormat = datePickerDateFormat;
  public readonly filterTypeLabel = filterTypeLabel;

  remove(): void {
    this.filtersFacade.removeFilter(this.filter);
    this.modalService.close();
  }
}
